'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './density_requirements.routes';

export class DensityRequirementsComponent {
  /*@ngInject*/
  constructor() {
    this.message = 'Hello';
  }
}

export default angular.module('websiteApp.density_requirements', [uiRouter])
  .config(routes)
  .component('densityRequirements', {
    template: require('./density_requirements.html'),
    controller: DensityRequirementsComponent,
    controllerAs: 'densityRequirementsCtrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/account/density/density_requirements/density_requirements.component.js